import { RootState } from "src/store/types";

export const userCusSelector = (state: RootState) => state.authCus.user;
export const authTokenCusSelector = (state: RootState) =>
  state.authCus.authToken;
